import {OVERVIEW_PROJECT_OVERVIEW_RECEIVE, OVERVIEW_CAMPING_STATS_RECEIVE} from "../config/actions";

let defaultState = {
    projectOverview: false,
    campingStats: null
};

const overviewReducer = (state = defaultState, action) => {
    switch (action.type) {
        case OVERVIEW_PROJECT_OVERVIEW_RECEIVE:
            return Object.assign({}, state, {
                projectOverview: action.data
            });
        case OVERVIEW_CAMPING_STATS_RECEIVE:
            return Object.assign({}, state, {
                campingStats: action.data
            });
        default:
            return state;
    }
};

export default overviewReducer;